//------------------------------------------------------------------------------
// This file is auto-generated.
//------------------------------------------------------------------------------
// This file was generated by NTypewriter from the C# ViewModel class with the
// same class/interface name.
//
// Do not change this file.  Any changes may cause incorrect behaviour and will
// be lost if the code is regenerated.
//------------------------------------------------------------------------------

import { ItemBase } from '../internal/ItemBase';
import { BillingProfileDefaultMode } from './Enums';

export class BillingProfileUpdateItem extends ItemBase {
    BillingRate?: number;
    DefaultBillingMode?: BillingProfileDefaultMode;
    EventCategoryID?: string | null;
    LessonDuration?: number;
    MakeUpMinutes?: number;

    constructor(initializer?: Partial<BillingProfileUpdateItem>) {
        super();
        if (initializer) {
            Object.assign(this, initializer);
        }
    }

    static readonly ClassName: string = "BillingProfileUpdateItem";
}
